import { useAuthStore } from '~/stores/auth/auth.store';

const authRoutes = ['/login', '/register'];
const unAuthRedirectPath = '/login';
const authRedirectPath = '/';

export default defineNuxtRouteMiddleware(async (to, from) => {
  const $auth = useAuthStore();
  const user = await $auth.getUser();

  if (!user && !authRoutes.some((route) => to.path.startsWith(route))) {
    return navigateTo({
      path: unAuthRedirectPath,
      query: { redirect: to.fullPath },
    });
  }
  if (user && authRoutes.some((route) => to.path.startsWith(route))) {
    const r = to.query.redirect as string | undefined;
    return navigateTo({ path: r ?? authRedirectPath });
  }

  // await new Promise((r) => setTimeout(r, 5000));
});
